"use strict";
exports.__esModule = true;
exports.getValueFromOptions = void 0;
// TODO: remove dependency from this legacy function
exports.getValueFromOptions = function (val, options) {
    var isArray = Array.isArray(val);
    var filteredOptions = options.filter(function (option) {
        return isArray ? val.indexOf(option.value) > -1 : option.value === val;
    });
    // val can also be of type object in that case return val or default object
    if (typeof val === 'object' && !isArray)
        return val || { value: '' };
    return isArray ? filteredOptions : filteredOptions[0] || { value: '' };
};
